import React from 'react';
import { Card as MUICard, CardContent, CardHeader, CardActions, styled } from '@mui/material';

export interface CardProps {
  /** Card title */
  title?: React.ReactNode;
  /** Card subtitle */
  subtitle?: React.ReactNode;
  /** Card content */
  children: React.ReactNode;
  /** Card actions/buttons */
  actions?: React.ReactNode;
  /** Card elevation (shadow depth) */
  elevation?: number;
  /** Additional props */
  sx?: any;
  /** Class name */
  className?: string;
}

const StyledCard = styled(MUICard)(({ theme }) => ({
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[3],
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

const StyledCardContent = styled(CardContent)({
  flexGrow: 1,
});

export const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  children,
  actions,
  elevation = 3,
  ...rest
}) => {
  return (
    <StyledCard elevation={elevation} {...rest}>
      {(title || subtitle) && (
        <CardHeader 
          title={title} 
          subheader={subtitle} 
          titleTypographyProps={{ variant: 'h6' }}
          subheaderTypographyProps={{ variant: 'body2' }}
        />
      )}
      <StyledCardContent>{children}</StyledCardContent>
      {actions && <CardActions>{actions}</CardActions>}
    </StyledCard>
  );
};

export default Card;
